import React, { useState } from 'react';

const FileSection = ({
  title,
  isCollapsed,
  onToggleCollapse,
  files,
  onLoadBackup,
  driveLinkKey,
  modifiedTimeKey,
  nameKey
}) => {
  const [collapsedFileGroups, setCollapsedFileGroups] = useState({});

  // Group output files by version and then by timestamp
  const groupFilesByVersion = (files) => {
    const groups = {};

    files.forEach(file => {
      // Extract version from filename (e.g., SMA-schedule-v44-... or SMA-schedule-report-v44-...)
      const scheduleMatch = file[nameKey]?.match(/SMA-schedule-v(\d+)-/);
      const reportMatch = file[nameKey]?.match(/SMA-schedule-report-v(\d+)-/);
      const failureReportMatch = file[nameKey]?.match(/SMA-schedule-failure-report-v(\d+)-/);
      const versionMatch = scheduleMatch || reportMatch || failureReportMatch;
      const version = versionMatch ? `v${versionMatch[1]}` : 'unversioned';

      // Extract timestamp from filename (MM-DD-YYYY-HH-MM-SS)
      const timestampMatch = file[nameKey]?.match(/(\d{2})-(\d{2})-(\d{4})-(\d{2})-(\d{2})-(\d{2})/);
      const timestamp = timestampMatch ? timestampMatch[0] : 'no-timestamp';

      if (!groups[version]) {
        groups[version] = {};
      }
      if (!groups[version][timestamp]) {
        groups[version][timestamp] = [];
      }
      groups[version][timestamp].push(file);
    });

    return groups;
  };

  const formatFileGroupTitle = (version) => {
    if (version === 'unversioned') return 'Unversioned Files';

    return `SMA-Schedule-Files-${version}`;
  };

  const toggleFileGroup = (version) => {
    setCollapsedFileGroups(prev => ({
      ...prev,
      [version]: !prev[version]
    }));
  };

  return (
    <div className="output-files-section">
      <div className="section-header" onClick={onToggleCollapse}>
        <h2>{title}</h2>
        <span className="collapse-icon">{isCollapsed ? '+' : '-'}</span>
      </div>
      <div className={`section-content ${isCollapsed ? 'collapsed' : 'expanded'}`}>
        {title === 'Config Files Backup' && files.length > 0 && (
          <ul>
            {files.map((file, index) => {
              const versionMatch = file.match(/SMA-scheduler-config-v(\d+)-(\d{2})-(\d{2})-(\d{4})-(\d{2})-(\d{2})-(\d{2})\.json/);
              const version = versionMatch ? `v${versionMatch[1]}` : 'unknown';
              const dateStr = versionMatch ? `${versionMatch[2]}/${versionMatch[3]}/${versionMatch[4]}, ${versionMatch[5]}:${versionMatch[6]}:${versionMatch[7]}` : file;
              return (
                <li key={index} onClick={() => onLoadBackup(file)} style={{ cursor: 'pointer' }}>
                  <div>
                    <strong>{file}</strong>
                    <br />
                    <small>Version: {version} | Saved on: {dateStr}</small>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
        {title === 'Schedule Files' && files.length > 0 && (
          <div className="file-groups">
            {Object.entries(groupFilesByVersion(files))
              .sort(([a], [b]) => {
                if (a === 'unversioned') return 1;
                if (b === 'unversioned') return -1;
                const numA = parseInt(a.replace('v', ''));
                const numB = parseInt(b.replace('v', ''));
                return numB - numA; // Sort by version descending
              })
              .map(([version, timestampGroups]) => (
                <div key={version} className="file-group">
                  <div
                    className="file-group-header"
                    onClick={() => toggleFileGroup(version)}
                  >
                    <h3>{formatFileGroupTitle(version)}</h3>
                    <span className="collapse-icon">
                      {collapsedFileGroups[version] !== false ? '+' : '-'}
                    </span>
                  </div>
                  <div className={`file-group-content ${collapsedFileGroups[version] !== false ? 'collapsed' : 'expanded'}`}>
                    {Object.entries(timestampGroups)
                      .sort(([a], [b]) => {
                        if (a === 'no-timestamp') return 1;
                        if (b === 'no-timestamp') return -1;
                        return b.localeCompare(a); // Sort by timestamp descending
                      })
                      .map(([timestamp, files]) => (
                        <div key={timestamp} className="timestamp-subgroup" style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '8px', margin: '8px 0', backgroundColor: '#f9f9f9' }}>
                          <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', fontWeight: 'bold' }}>Timestamp: {timestamp}</h4>
                          {files.map((file, index) => (
                            <div key={file.id || index} style={{ marginBottom: '8px', padding: '4px 0' }}>
                              <a href={file[driveLinkKey]} target="_blank" rel="noopener noreferrer" style={{ fontWeight: '500', color: '#2196f3', textDecoration: 'none' }}>
                                {file[nameKey]}
                              </a>
                              <br />
                              <small>Last modified: {new Date(file[modifiedTimeKey]).toLocaleDateString('en-US')} {new Date(file[modifiedTimeKey]).toLocaleTimeString('en-US', { hour12: false })}</small>
                            </div>
                          ))}
                        </div>
                      ))}
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FileSection;
